import React, {type ComponentType} from 'react';
import type {AtomRenderProps} from '@packages/systems/wfdl';
import {Atom} from '@packages/systems/wfdl';

const withAttribute =
  (key: string, value: string) =>
  (Component: ComponentType<AtomRenderProps>) => {
    const NewComponent = (props: AtomRenderProps) => {
      const newProps = {
        ...props,
        attributes: props.attributes.set(key, value),
      } as const;
      return <Component {...newProps} />;
    };

    return Atom.createRender(NewComponent);
  };

export default withAttribute;
